import React from 'react';
import classnames from 'classnames';
import HiddenIcon from '../../../Icons/Hidden';
import { IconSize } from '../../../Icons/IconWrap';
import Flex from '../../../Flex';
import s from './Hidden.scss';
var HiddenDumbView = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, deviation = _a.deviation;
    return (React.createElement("div", { className: classnames(s['root'], className), style: {
            width: width || height,
            height: height || width,
        } },
        React.createElement(Flex, { className: s['blocked'], justifyContent: "center", alignItems: "center" },
            React.createElement(HiddenIcon, { size: IconSize.HUGE }))));
};
HiddenDumbView.displayName = 'HiddenDumbView';
export default HiddenDumbView;
//# sourceMappingURL=Hidden.js.map